import * as React from "react";
import { PolymorphicPlayerCard } from "@/services/bedrock";
import { Dropdown } from "semantic-ui-react";
import { useFormContext, useWatch } from "react-hook-form";
import { useContext } from "react";
import PlayerCardField from "./Fields/PlayerCardField";
import { PlayerCardSettingsContext } from "../../../Contexts";
import RecordSelector from "../../../RecordSelector";
import CustomTitleField from "@/containers/PlayerCardSettings/Tabs/PlayerCardTab/Components/Fields/CustomTitleField";

interface SmartLinkWidgetSettingsProps {
  index: number;
}

const SmartLinkWidgetSettings: React.FC<SmartLinkWidgetSettingsProps> = ({ index }) => {
  const { control } = useFormContext<PolymorphicPlayerCard>();
  const { SmartLinks } = useContext(PlayerCardSettingsContext);
  const selectionType = useWatch({ control, name: `widgets.${index}.owner.selectionType` });

  return (
    <div className="playerCardWidgetOwner playerCardSmartLink">
      <PlayerCardField
        index={index}
        fieldName="styleType"
        fieldLabel="Link Style"
        rules={{ required: "This is required." }}
        component={Dropdown}
        placeholder="Link Style"
        selection
        options={[
          { text: "Card Style", value: "CARD" },
          { text: "Button Style", value: "BUTTON" },
        ]}
      />
      <PlayerCardField
        index={index}
        fieldName="selectionType"
        fieldLabel="Selection Type"
        rules={{ required: "This is required." }}
        component={Dropdown}
        placeholder="Selection Type"
        selection
        options={[
          { text: "Specific", value: "SPECIFIC" },
          { text: "Random", value: "RANDOM" },
          { text: "Most Recent", value: "MOST_RECENT" },
        ]}
      />
      {selectionType === "SPECIFIC" && (
        <PlayerCardField
          index={index}
          fieldName="smartLinkId"
          fieldLabel="Smart Link"
          rules={{ required: "This is required." }}
          component={RecordSelector}
          context={SmartLinks}
        />
      )}
      <CustomTitleField index={index} />
    </div>
  );
};
export default SmartLinkWidgetSettings;
